module.exports = __webpack_public_path__ + "img/location_services_de.8c782a59.svg";